export const getFtpOptions = (list) =>
  list?.map((item) => ({ label: item.name, value: item.name }));
